import { getCurrentUser } from './api';

// eslint-disable-next-line import/prefer-default-export
export const currentUserQuery = (enabled: boolean) => ({
  queryKey: ['current_user'],
  queryFn: getCurrentUser,
  enabled,
  staleTime: 60 * 1000,
});
